export const PERIODICAL_REPORT_TOGGLE_DIALOG = 'PERIODICAL_REPORT_TOGGLE_DIALOG'
export const PERIODICAL_REPORT_UPDATE_LIST = 'PERIODICAL_REPORT_UPDATE_LIST'
export const PERIODICAL_REPORT_UPDATE_LIST_METHOD = 'PERIODICAL_REPORT_UPDATE_LIST_METHOD'
export const PERIODICAL_REPORT_UPDATE_FORM = 'PERIODICAL_REPORT_UPDATE_FORM'
export const PERIODICAL_REPORT_UPDATE_FORM_ERROR = 'PERIODICAL_REPORT_UPDATE_FORM_ERROR'
export const PERIODICAL_REPORT_UPDATE_FORM_FIELD = 'PERIODICAL_REPORT_UPDATE_FORM_FIELD'

export const toggleDialog = (type, form = {}) => ({
  type: PERIODICAL_REPORT_TOGGLE_DIALOG,
  payload: { type, form }
})
export const updatePeriodicalReportList = ({ data, count }) => ({
  type: PERIODICAL_REPORT_UPDATE_LIST,
  payload: { data, count }
})
export const updatePeriodicalReportListMethod = (method, data) => ({
  type: PERIODICAL_REPORT_UPDATE_LIST_METHOD,
  payload: { method, data }
})
export const updatePeriodicalReportForm = (form) => ({
  type: PERIODICAL_REPORT_UPDATE_FORM,
  payload: form
})
export const updatePeriodicalReportFormError = (error = null) => ({
  type: PERIODICAL_REPORT_UPDATE_FORM_ERROR,
  payload: error
})
export const updatePeriodicalReportFormField = (field, value) => ({
  type: PERIODICAL_REPORT_UPDATE_FORM_FIELD,
  payload: { field, value }
});

// Periodical report current data
export const PERIODICAL_REPORT_UPDATE_YEAR_LEVELS = 'PERIODICAL_REPORT_UPDATE_YEAR_LEVELS'
export const PERIODICAL_REPORT_UPDATE_LEARNING_AREAS = 'PERIODICAL_REPORT_UPDATE_LEARNING_AREAS'
export const PERIODICAL_REPORT_UPDATE_ASSESSMENT_AREAS = 'PERIODICAL_REPORT_UPDATE_ASSESSMENT_AREAS'

export const updatePeriodicalReportYearLevels = (yearLevels = []) => ({
  type: PERIODICAL_REPORT_UPDATE_YEAR_LEVELS,
  payload: yearLevels
})
export const updatePeriodicalReportLearningAreas = (learningAreas = []) => ({
  type: PERIODICAL_REPORT_UPDATE_LEARNING_AREAS,
  payload: learningAreas
})
export const updatePeriodicalReportAssessmentAreas = (assessmentAreas = []) => ({
  type: PERIODICAL_REPORT_UPDATE_ASSESSMENT_AREAS,
  payload: assessmentAreas
})


// Periodical report marking

export const PERIODICAL_REPORT_UPDATE_STUDENTS = 'PERIODICAL_REPORT_UPDATE_STUDENTS'
export const PERIODICAL_REPORT_UPDATE_STUDENT = 'PERIODICAL_REPORT_UPDATE_STUDENT'
export const PERIODICAL_REPORT_UPDATE_MODE = 'PERIODICAL_REPORT_UPDATE_MODE'

export const updatePeriodicalReportMarkingStudents = (students = []) => ({
  type: PERIODICAL_REPORT_UPDATE_STUDENTS,
  payload: students
})
export const updatePeriodicalReportMarkingStudent = (student) => ({
  type: PERIODICAL_REPORT_UPDATE_STUDENT,
  payload: student
})
export const updatePeriodicalReportMarkingMode = (mode) => ({
  type: PERIODICAL_REPORT_UPDATE_MODE,
  payload: mode
})
